import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaSun, FaMoon } from 'react-icons/fa';

export default function App() {
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    document.documentElement.classList.toggle('dark', darkMode);
  }, [darkMode]);

  return (
    <div className="min-h-screen transition-colors duration-500 px-6 py-8">
      <header className="flex justify-between items-center max-w-5xl mx-auto mb-8">
        <h1 className="text-4xl font-bold">Shubham Kaushal</h1>
        <button onClick={() => setDarkMode(!darkMode)} aria-label="Toggle Theme">
          {darkMode ? <FaSun size={22} /> : <FaMoon size={22} />}
        </button>
      </header>

      <motion.section className="max-w-5xl mx-auto" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
        <h2 className="text-2xl font-semibold mb-4">Frontend Developer</h2>
        <p className="mb-6 text-gray-700 dark:text-gray-300">
          Passionate about building modern, performant, and user-centric applications using React.js and the modern web stack.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="p-4 border rounded-lg shadow-sm bg-white dark:bg-gray-800 dark:border-gray-700">
            <h3 className="text-lg font-semibold">Movie Booking System</h3>
            <p className="text-sm text-gray-600 dark:text-gray-300">
              Full-stack app with booking, admin panel, seat locking, OMDB integration.
            </p>
          </div>
          <div className="p-4 border rounded-lg shadow-sm bg-white dark:bg-gray-800 dark:border-gray-700">
            <h3 className="text-lg font-semibold">Online Exam Portal</h3>
            <p className="text-sm text-gray-600 dark:text-gray-300">
              Auto-grading exam system with Excel question uploads and student stats.
            </p>
          </div>
        </div>
      </motion.section>
    </div>
  );
}
